import { CONTENT_BOARD_BG_SHAPE_ID } from 'features/content-whiteboard/constants';
import type { Editor, TLAsset, TLAssetId } from '@digitalsamba/tldraw';
import { getTldrawSync } from 'utils/whiteboard/tldrawRuntime';

export type initBgImageOptions = {
  imgUrl: string;
  editor: Editor;
  size: { width: number; height: number };
};

export const initializeBackgroundImage = ({ imgUrl, editor, size }: initBgImageOptions) => {
  if (!editor) {
    return;
  }

  const { width, height } = size;

  if (width === 0 || height === 0) {
    return;
  }

  if (!imgUrl) {
    return;
  }

  const tldraw = getTldrawSync();
  const { AssetRecordType, getHashForString } = tldraw;

  const assetId: TLAssetId = AssetRecordType.createId(getHashForString(imgUrl));

  const asset: TLAsset = AssetRecordType.create({
    id: assetId,
    type: 'image',
    typeName: 'asset',
    props: {
      name: CONTENT_BOARD_BG_SHAPE_ID,
      src: imgUrl,
      w: width,
      h: height,
      mimeType: 'image/jpeg',
      isAnimated: false,
    },
    meta: {
      src: imgUrl,
      isBackground: true,
    },
  });

  editor.createAssets([asset]);

  const shapeData = {
    id: CONTENT_BOARD_BG_SHAPE_ID,
    type: 'inactive-image',
    x: 0,
    y: 0,
    isLocked: true,
    index: 'a1',
    opacity: 0,
    props: {
      assetId,
      w: width,
      h: height,
      url: imgUrl,
    },
    meta: {
      src: imgUrl,
    },
  };

  editor.createShape(shapeData);

  editor.sendToBack([CONTENT_BOARD_BG_SHAPE_ID]);

  try {
    editor.resetZoom?.();
    const imgShape = editor.getShape(CONTENT_BOARD_BG_SHAPE_ID)!;

    const bounds = editor.getShapePageBounds(imgShape);
    if (bounds && bounds.width > 0 && bounds.height > 0) {
      editor.zoomToBounds(bounds, 1);
    }
  } catch (e) {
    console.error(e);
  }
};
